import { Provider } from '@angular/core';
import { SearchService } from 'app-shell-data';
import { provideFeatureImportComponents } from 'common-util';
import { ProductQuickSearchComponentStore } from 'product-quick-search-data';
import { ProductQuickSearchService } from './product-quick-search.service';
import { ProductQuickSearchResultsProviderComponent } from './provided-components/product-quick-search-results-provider/product-quick-search-results-provider.component';

export function provideProductQuickSearchFeature(): Provider {
  return [
    ProductQuickSearchComponentStore,
    provideFeatureImportComponents(ProductQuickSearchResultsProviderComponent),
    {
      provide: SearchService,
      useClass: ProductQuickSearchService,
    },
  ];
}
